import { apiAxiosCMS } from 'services/api';
import { BannerPlpProps } from 'types/BannerPlpProps';

interface RespReqProps {
	isSuccess: boolean;
	bannerSaved: BannerPlpProps | null;
}

export async function addBannerReq(
	form: BannerPlpProps,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	setMessage: React.Dispatch<React.SetStateAction<string>>,
	handleNotify: any
) {
	const respReq: RespReqProps = {
		isSuccess: false,
		bannerSaved: null
	};

	setMessage('Salvando banner...');
	setIsLoad(true);

	const payload: any = { ...form };

	if (form.redirectId === 'collections') {
		payload.query = ' ';
		payload.redirectValue = ' ';
	} else {
		payload.collections = [];
	}

	delete payload.id;

	await apiAxiosCMS
		.post('/plp-banner', payload)
		.then((res) => {
			respReq.isSuccess = true;
			respReq.bannerSaved = res.data;
			handleNotify('Banner adicionado com sucesso.', 'success');
		})
		.catch(() => {
			respReq.isSuccess = false;
			respReq.bannerSaved = null;
			handleNotify('Erro ao adicionar banner.', 'error');
		});

	setIsLoad(false);

	return respReq;
}

export async function editBannerReq(
	bannerToEdit: BannerPlpProps,
	form: BannerPlpProps,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	setMessage: React.Dispatch<React.SetStateAction<string>>,
	handleNotify: any
) {
	const respReq = {
		isSuccess: false
	};

	setMessage('Editando banner');
	setIsLoad(true);

	const payload: any = { ...form };

	if (form.redirectId === 'collections') {
		payload.query = ' ';
		payload.redirectValue = ' ';
	} else {
		payload.collections = [];
	}

	delete payload.id;

	await apiAxiosCMS
		.patch(`/plp-banner/${bannerToEdit.id}`, payload)
		.then(() => {
			respReq.isSuccess = true;
			handleNotify('Banner editado com sucesso.', 'success');
		})
		.catch(() => {
			respReq.isSuccess = false;
			handleNotify('Erro ao editar banner.', 'error');
		});

	setIsLoad(false);

	return respReq;
}
